<template>
  <section class="fo-card">
    <div class="fo-card-loading loading loading-lg" v-if="loading"></div>
    <div class="fo-card-head">
      <h2 class="fo-card-title">
        Evolução dos últimos 12 meses<small>{{ regimeLabel }}</small>
      </h2>
      <button type="button" class="fo-link" @click="table = !table">
        {{ table ? 'Ver gráfico' : 'Ver como tabela' }}
      </button>
    </div>
    <div class="fo-legend">
      <span><i class="fo-legend-revenue"></i>Receitas</span>
      <span><i class="fo-legend-expense"></i>Despesas</span>
      <span><i class="fo-legend-line"></i>Resultado</span>
    </div>

    <table class="table fo-table" v-if="table">
      <thead>
        <tr>
          <th>Mês</th>
          <th class="text-right">Receitas</th>
          <th class="text-right">Despesas</th>
          <th class="text-right">Resultado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="month in months" :key="month.month">
          <td>{{ monthName(month) }}</td>
          <td class="text-right">{{ money(month.revenue) }}</td>
          <td class="text-right">{{ money(month.expense) }}</td>
          <td class="text-right" :class="{ 'text-error': month.result < 0 }">
            {{ money(month.result) }}
          </td>
        </tr>
      </tbody>
    </table>

    <grouped-bars v-else :groups="groups" :hidden="hidden" :height="230">
      <template v-slot:tip="{ group }">
        <strong>{{ group.name }}</strong>
        <div class="fo-tip-row">
          <span><i class="fo-dot fo-dot-revenue"></i>Receitas</span>
          <b>{{ money(group.revenue) }}</b>
        </div>
        <div class="fo-tip-row">
          <span><i class="fo-dot fo-dot-expense"></i>Despesas</span>
          <b>{{ money(group.expense) }}</b>
        </div>
        <div class="fo-tip-row fo-tip-total">
          <span>Resultado</span>
          <b :class="{ 'text-error': group.result < 0 }">{{ money(group.result) }}</b>
        </div>
      </template>
    </grouped-bars>
  </section>
</template>

<script>
import GroupedBars from './GroupedBars.vue';
import {
  money, monthLabel, monthName,
} from './helpers';

export default {
  components: {
    GroupedBars,
  },
  props: {
    months: {
      type: Array,
      default: () => [],
    },
    regime: {
      type: String,
      default: 'competence',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      table: false,
    };
  },
  computed: {
    regimeLabel() {
      return this.regime === 'cash' ? 'caixa · mês atual até hoje' : 'competência · mês atual parcial';
    },
    groups() {
      return this.months.map(month => ({
        key: month.month,
        label: monthLabel(month.month),
        name: this.monthName(month),
        revenue: month.revenue,
        expense: month.expense,
        result: month.result,
        line: month.result,
        partial: month.partial,
      }));
    },
  },
  methods: {
    money(value) {
      return money(value, this.hidden);
    },
    monthName(month) {
      const name = monthName(month.month);
      return month.partial ? `${name} (parcial)` : name;
    },
  },
};
</script>
